import type { TourId } from "./types";

export type TourState =
  | { phase: "idle" }
  | { phase: "intro"; tourId: TourId }
  | { phase: "step"; tourId: TourId; index: number }
  | { phase: "finished"; tourId: TourId };

export type TourAction =
  | { type: "start"; tourId: TourId }
  | { type: "begin" }
  | { type: "next"; stepCount: number }
  | { type: "dismiss" }
  | { type: "closeSnackbar" }
  | { type: "reset" };

export const IDLE: TourState = { phase: "idle" };

/** Pure transitions. Marking seen is the provider's job, not the reducer's. */
export const tourReducer = (state: TourState, action: TourAction): TourState => {
  switch (action.type) {
    case "start":
      return state.phase === "idle" || state.phase === "finished"
        ? { phase: "intro", tourId: action.tourId }
        : state;
    case "begin":
      return state.phase === "intro" ? { phase: "step", tourId: state.tourId, index: 0 } : state;
    case "next":
      if (state.phase !== "step") return state;
      return state.index + 1 >= action.stepCount
        ? { phase: "finished", tourId: state.tourId }
        : { ...state, index: state.index + 1 };
    case "dismiss":
      return state.phase === "intro" || state.phase === "step" ? IDLE : state;
    case "closeSnackbar":
      return state.phase === "finished" ? IDLE : state;
    case "reset":
      return IDLE;
  }
};
